import * as React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import AllowanceListings from '../components/listings/AllowanceListings';
import ErrorPage from './ErrorPage';
import DraggableProfilePanel from '../components/common/DraggableProfilePanel';

function AllowanceListingsPage() {
    const { isAuthenticated } = useAuth0();
    return (
        isAuthenticated ? 
        <>
            {/* <Header isVisible={true} buttonsVisible={true}/>
            <AllowanceListings />
            <Footer /> */}

        <div className="parent-container">
            <div className="container">
                <div className="header-class">
                <Header isVisible={true} buttonsVisible={true}/>
                </div>
            <div className="content-class">
                <DraggableProfilePanel/>
                <AllowanceListings />
            </div>
            <div className="footer-class">
                <Footer />
            </div>
            </div>
      </div>
        </> 
         : <ErrorPage />
    );
}

export default AllowanceListingsPage;